import React from "react"


export const HomeContainerData=[
    {
        firstPara:"Now better than ever",
        name:"Create Beautifull websites easy fast & without hustle!",
        button:"GET A FREE TEMPLATE",
        icon1:<i class="fab fa-facebook-f"></i>,
        icon2:<i class="fab fa-twitter"></i>,
        icon3:<i class="fab fa-instagram"></i>,
        icon4:<i class="fab fa-linkedin-in"></i>,
        icon5:<i class="fab fa-google"></i>,
    }
]